import React from "react";
import { motion } from "framer-motion";
import { Check, Music2, Radio, Sparkles, Info } from "lucide-react";
import { SERVICES_META } from "@/lib/constants";

const ICONS = { cerimonia: Music2, banda: Radio, astrolive: Sparkles };

export const ServicesStep = ({ services, onChange, adminConfigured }) => {
  const s = services || { cerimonia: true, banda: false, astrolive: false };
  const toggle = (key) => {
    if (adminConfigured) return; // locked when pre-set by LC
    onChange({ ...s, [key]: !s[key] });
  };
  return (
    <motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.35 }} className="mx-auto max-w-2xl">
      <h2 className="font-serif text-2xl font-semibold text-[color:var(--brand-graphite)] sm:text-3xl">Quais serviços vocês contrataram conosco?</h2>
      <p className="mt-2 text-sm text-[color:var(--brand-muted)]">Selecione os serviços do seu evento — mostraremos apenas o que faz sentido para vocês.</p>
      {adminConfigured && (
        <div className="mt-3 flex items-start gap-2 rounded-xl border border-[color:var(--brand-champagne)] bg-[color:var(--brand-champagne-soft)] p-3 text-sm text-[color:var(--brand-graphite)]">
          <Info className="mt-0.5 h-4 w-4 shrink-0 text-[color:var(--brand-marsala)]" />
          <span>* Estes serviços já foram definidos pela equipe LC conforme sua contratação. Qualquer ajuste, fale conosco.</span>
        </div>
      )}
      <div className="mt-6 grid gap-3 sm:grid-cols-1">
        {Object.entries(SERVICES_META).map(([key, meta]) => {
          const Icon = ICONS[key];
          const active = !!s[key];
          return (
            <button
              key={key}
              type="button"
              data-testid={`service-card-${key}`}
              onClick={() => toggle(key)}
              className={`flex items-center gap-4 rounded-2xl border p-4 text-left transition-all ${
                active
                  ? "border-[color:var(--brand-marsala)] bg-[color:var(--brand-marsala-soft)] shadow-[0_6px_18px_rgba(122,46,58,0.10)]"
                  : "border-[color:var(--brand-border)] bg-white hover:bg-[color:var(--brand-paper)]"
              } ${adminConfigured ? "cursor-default" : ""}`}
            >
              <span className={`flex h-12 w-12 items-center justify-center rounded-xl ${active ? "bg-[color:var(--brand-marsala)] text-white" : "bg-[color:var(--brand-paper)] text-[color:var(--brand-muted)]"}`}>
                <Icon className="h-6 w-6" />
              </span>
              <div className="flex-1">
                <p className="font-serif text-lg font-semibold text-[color:var(--brand-graphite)]">{meta.label}</p>
                <p className="text-sm text-[color:var(--brand-muted)]">{meta.desc}</p>
              </div>
              <span className={`flex h-6 w-6 items-center justify-center rounded-md border ${active ? "border-[color:var(--brand-marsala)] bg-[color:var(--brand-marsala)] text-white" : "border-[color:var(--brand-border)]"}`}>
                {active && <Check className="h-4 w-4" />}
              </span>
            </button>
          );
        })}
      </div>
    </motion.div>
  );
};
